import { EventEmitter } from 'fitify-ui/src/utils/event-emitter'

const eventEmitter = new EventEmitter()
const ONBOARDING_PAGE_TRANSITION_EVENT = 'onboarding-page-transition-event'

export const emitOnboardingPageTransitionEvent = () => {
  eventEmitter.emit(ONBOARDING_PAGE_TRANSITION_EVENT)
}

export const addAnimationEventListener = (listener: () => void) => {
  eventEmitter.addListener(ONBOARDING_PAGE_TRANSITION_EVENT, listener)
}

export const removeAnimationEventListener = (listener: () => void) => {
  eventEmitter.removeListener(ONBOARDING_PAGE_TRANSITION_EVENT, listener)
}
